<template>
    <div>
        <div class="left">
            <el-form ref="form" :model="form" label-width="80px">
                <el-form-item label="通知标题">
                    <el-input v-model="form.title"></el-input>
                </el-form-item>
                <el-form-item label="通知详情">
                    <el-input type="textarea" v-model="form.text"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-upload
                            class="upload-demo"
                            action="https://jsonplaceholder.typicode.com/posts/"
                            :on-preview="handlePreview"
                            :on-remove="handleRemove"
                            :file-list="form.fileList"
                            :limit="1"
                            list-type="picture">
                        <el-button size="small" type="primary">点击上传</el-button>
                        <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，最多上传一张图片</div>
                    </el-upload>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="onSubmit">立即创建</el-button>
                    <el-button>取消</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="right">
            <el-checkbox v-model="form.sendToAll">同时发送给学生家长</el-checkbox>
            <el-checkbox v-model="form.sendToParents">只发送给家长</el-checkbox>

            <div style="margin: 10px 0;display: flex">
                <div style="width: 15%;line-height: 35px">学期：</div>
                <div style="width: 80%">
                    <el-select v-model="semester_id" placeholder="请选择学期" @change="handleGetStudents">
                        <el-option
                                v-for="item in $parentInfo.semesters"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div style="margin: 10px 0;display: flex">
                <div style="width: 15%;line-height: 35px">学校：</div>
                <div style="width: 80%">
                    <el-select v-model="school_id" placeholder="请选择学校" @change="handleGetStudents">
                        <el-option
                                v-for="item in $parentInfo.schools"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div style="margin:10px 0;display: flex">
                <div style="width: 15%;line-height: 35px">年级：</div>
                <div style="width: 80%">
                    <el-select v-model="grade_id" placeholder="请选择年级" @change="handleGetStudents">
                        <el-option
                                v-for="item in $parentInfo.grades"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div style="margin:10px 0;display: flex">
                <div style="width: 15%;line-height: 35px">班主任：</div>
                <div style="width: 80%">
                    <el-select v-model="headTeacher_id" placeholder="请选择年级" @change="handleGetStudents">
                        <el-option
                                v-for="item in $parentInfo.headTeachers"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div>
                <div class="m-portlet__body">
                    <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">
                        全选
                    </el-checkbox>
                    <div style="margin: 15px 0;"></div>
                    <div style="height: 300px;overflow: auto;">
                        <el-checkbox-group v-model="checkedStudents" @change="handleCheckedCitiesChange">
                            <el-checkbox v-for="student in $parentInfo.students" :label="student.name" :key="student.id" style="width: 80px">{{student.name}}
                            </el-checkbox>
                        </el-checkbox-group>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Dialog_CreateMessage",
        data() {
            return {
                form: {
                    title: '',
                    text: '',
                    fileList: [],
                    sendToAll: '',
                    sendToParents: '',
                },
                semester_id: '',
                school_id: '',
                headTeacher_id: '',
                grade_id: '',
                checkAll: false,
                checkedStudents: [],
                isIndeterminate: true
            }
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
        },
        methods: {
            onSubmit() {
                this.$wApi.send(this.$parentInfo.path, 'give_message_user', this.form);
            },
            handleRemove(file, fileList) {
                console.log(file, fileList);
            },
            handleGetStudents(){
                this.$wApi.send(this.$parentInfo.path, 'get_students', {
                    'grade_id': this.grade_id,
                    'headTeacher_id': this.headTeacher_id,
                    'school_id': this.school_id,
                    'semester_id': this.semester_id,
                });
            },
            handlePreview(file) {
                console.log(file);
            },
            handleCheckAllChange(val) {
                this.checkedStudents = val ? this.$parentInfo.students : [];
                this.isIndeterminate = false;
            },
            handleCheckedCitiesChange(value) {
                let checkedCount = value.length;
                this.checkAll = checkedCount === this.this.$parentInfo.students.length;
                this.isIndeterminate = checkedCount > 0 && checkedCount < this.$parentInfo.students.length;
            }
        }
    }
</script>


<style scoped lang="scss">
    .left {
        float: left;
        width: 450px;
    }

    .right {
        margin-left: 500px;
    }
</style>